// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar__avatar___6-N\\+m{border-radius:50%;overflow:hidden}.avatar__customImg___P8f5Z{width:100%;height:100%;background-size:100%;display:initial}.avatar__hideImg___OtZCK{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#006cec",
	"primaryDarkerBlue": "#0047b9",
	"primarySlate": "#27353b",
	"borderPrimary": "#dce0e9",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "calc(100% - 30px)",
	"widgetFrameMaxHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"widgetMinWidth": "400px",
	"widgetMaxWidth": "720px",
	"avatar": "avatar__avatar___6-N+m",
	"customImg": "avatar__customImg___P8f5Z",
	"hideImg": "avatar__hideImg___OtZCK"
};
export default ___CSS_LOADER_EXPORT___;
